import React from "react"
import "./MemberProfileUpload.scss"
import { selectIcon, SVG } from "../../UI/selector"
import { imageError } from "../../../services/subscriberService"

const MemberProfileUpload = ({ image, name, showError, ...props }) => {
  return (
    <div className="MemberProfilePicDiv">
      <div
        className={`MemberProfilePicContainer${showError ? " inputError" : ""}`}
      >
        <img
          src={image === "" ? selectIcon("userDummy1") : image}
          alt="profile"
          onError={imageError}
        />
        <div className="ProfileIconCircle">
          <SVG src={selectIcon("editProfileImageIcon")} />
          {props.children}
        </div>
      </div>
      {name && <p>{name}</p>}
    </div>
  )
}

export default MemberProfileUpload
